import { initializeTracker } from '../Tracker';
const DEFAULT_ENV = 'production';

export const getApiEnv = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlMatch = window.location.pathname.match(/([a-z]+\d*)\/app\//);
  const featureMatch = window.location.pathname.match(/feature\/([-\w]*)\/app\//);
  let token = urlParams.get('t');

  const fakeConv = urlParams.get('fakeConv');
  window.isFakeConv = fakeConv !== null;

  let MIXPANEL_TOKEN;
  let apiEnv = urlParams.get('apiEnv');
  if (!apiEnv) {
    if (urlMatch) {
      apiEnv = urlMatch[1];
      MIXPANEL_TOKEN = 'ea625306063fc8330cd2a8739ac349e1';
    } else if (featureMatch) {
      apiEnv = 'uat';
    } else {
      apiEnv = DEFAULT_ENV;
      MIXPANEL_TOKEN = '6f65e5831f228feb764f7dc765448d07';
    }
  } else {
    MIXPANEL_TOKEN = 'ea625306063fc8330cd2a8739ac349e1';
  }
  initializeTracker(MIXPANEL_TOKEN, token);
  return apiEnv;
};

export default getApiEnv;
